export { default } from './Index.vue';
